import { useRef, useState } from "react";
import { Camera, Loader2 } from "lucide-react";
import { Avatar } from "./Avatar";
import { api, errorMessage } from "../lib/api";
import { useT } from "../i18n";

export const PhotoUpload = ({ name, photoUrl, onUploaded, size = 96 }) => {
  const { t } = useT();
  const input = useRef(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const pick = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setError("");
    setBusy(true);
    const form = new FormData();
    form.append("file", file);
    try {
      const { data } = await api.post("/profile/photo", form, { headers: { "Content-Type": "multipart/form-data" } });
      onUploaded(data.photo_url);
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setBusy(false);
      e.target.value = "";
    }
  };

  return (
    <div className="flex items-center gap-4" data-testid="photo-upload">
      <button type="button" onClick={() => input.current?.click()} className="relative shrink-0 rounded-full" aria-label={t("a_change_photo")} data-testid="photo-upload-trigger">
        <Avatar name={name} src={photoUrl} size={size} ring={false} testId="photo-upload-avatar" />
        <span className="absolute -bottom-1 -right-1 flex h-8 w-8 items-center justify-center rounded-full bg-rox-orange text-rox-black" data-testid="photo-upload-indicator" data-busy={busy}>
          {busy ? <Loader2 size={15} strokeWidth={2.4} className="animate-spin" /> : <Camera size={15} strokeWidth={2.4} />}
        </span>
      </button>
      <div className="min-w-0">
        <p className="text-sm font-medium" data-testid="photo-upload-label">{busy ? t("photo_uploading") : photoUrl ? t("photo_change") : t("photo_add")}</p>
        <p className="text-xs text-rox-muted">{t("photo_hint")}</p>
        {error && <p className="mt-1 text-xs text-rox-orange" data-testid="photo-upload-error">{error}</p>}
      </div>
      <input ref={input} type="file" accept="image/jpeg,image/png,image/webp" className="hidden" onChange={pick} data-testid="photo-upload-input" />
    </div>
  );
};
